<template>
  <div class="navBox">
    
    <div class="box-list">
      <!-- <div class="boxBg"></div> -->
      <ul class="research_list">
         <router-link to="/factorAnalysis/singlefactor">
        <li>
          <img src="../../assets/image/factorAnalysis1.png"/>
          <div class="research_tit">
            <h3 class="list_name">单标的因子分析</h3>
          </div>
        </li>
        </router-link>
      </ul>
       <ul class="research_list">
         <router-link to="/factorAnalysis/singleanalysis">
        <li>
          <img src="../../assets/image/factorAnalysis2.png"/>
          <div class="research_tit">
            <h3 class="list_name">单天、单因子、多标的分析</h3>
          </div>
        </li>
        </router-link>
      </ul>
       <ul class="research_list">
         <router-link  to="/factorAnalysis/aloneanalysis">
        <li>
          <img src="../../assets/image/factorAnalysis3.png"/>
          <div class="research_tit">
            <h3 class="list_name">单因子分析</h3>
          </div>
        </li>
        </router-link>
      </ul>
      <ul class="research_list">
         <router-link  to="/factorAnalysis/multiplefactor">
        <li>
          <img src="../../assets/image/factorAnalysis4.png"/>
          <div class="research_tit">
            <h3 class="list_name">单天、多因子、多标的分析</h3>
          </div>
        </li>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: [],
    };
  },
  methods: {
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.navBox{
  background: #F7F9FF;
 
}
.box-list {
  padding: 24px 0 0 24px;
  .research_list {
    display: inline-block;
    margin: 0 15px;
    cursor: pointer;
    position: relative;
    color: #fff;
     margin-bottom: 20px;
    // background: #003D56;
    // box-shadow: inset 0px 0px 32px 0px rgba(63,152,241,1); // 内阴影
    // border-radius: 8px;
    img{
      height: 388px;
    }
  }
  .research_tit {
   position: absolute;
    bottom: 0;
    width: 320px;
    height: 89px;
    text-align: center;
    line-height: 66px;
    .list_name {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .list_desc {
      width: 130px;
      margin: 0 auto;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.boxBg {
  width: 330px;
  height: 395px;
  // background: url("../../assets/image/research1.png");
}
</style>